import axios from 'axios'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { baseUrl } from '../../utils/baseUrl.js'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./../../index.css";
import "./../../mainslider.css"
import { Navigation, Pagination } from "swiper";
import MainSlider from '../MainSlider/MainSlider.jsx';
import { FaStar } from 'react-icons/fa';
import { BsCartDash, BsCartPlus } from 'react-icons/bs';
import { WishListContext } from '../../Context/WishListContext.jsx';
import { CartContext } from '../../Context/CartContext.jsx';
import { VscHeart, VscHeartFilled } from 'react-icons/vsc';
import LoadingPage from '../LoadingPage/LoadingPage.jsx';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const Category = () => {
    const { addProductToWishList, removeProductFromWishList, contains, ids } = useContext(WishListContext)
    const { addProductToCart, removeProductFromCart, cartContains, cartIds } = useContext(CartContext)
    const [category, setCategory] = useState({})
    const [categoryProducts, setCategoryProducts] = useState([])

    const params = useParams()

    const getCategory = useCallback(async () => {
        await axios.get(`${baseUrl}/categories/${params.id}`).then(response => {
            setCategory(response.data?.category)
        }).catch(err => {
        })
    }, [params.id])

    const getCategoryProducts = useCallback(async () => {
        await axios.get(`${baseUrl}/products/category/${params.id}`).then(response => {
            setCategoryProducts(response.data.products)
        }).catch(err => {
        })
    }, [params.id])

    useEffect(() => {
        getCategory()
        getCategoryProducts()
    }, [getCategory, getCategoryProducts, params.id])

    return (
        <HelmetProvider>
            <Helmet>
                <title>FreshCart | Category</title>
            </Helmet>
            {category && category.SubCategories ?
                <>
                    <div className="container">
                        <MainSlider />
                        <h2 className="text-3xl text-center font-medium my-5 uppercase">{`${category.name?.charAt(0).toUpperCase() + category.name?.slice(1)}`}</h2>
                        <div className="flex flex-col">
                            <div className="flex justify-center items-center sm:flex-row gap-4 py-2 my-3 overflow-hidden">
                                <Swiper
                                    breakpoints={{
                                        375: {
                                            width: 375,
                                            slidesPerView: 2,
                                        },
                                        425: {
                                            width: 425,
                                            slidesPerView: 2,
                                        },
                                        576: {
                                            width: 576,
                                            slidesPerView: 3,
                                        },
                                        768: {
                                            width: 768,
                                            slidesPerView: 5,
                                        },
                                        1024: {
                                            width: 1024,
                                            slidesPerView: 7,
                                        },
                                        2048: {
                                            width: 2048,
                                            slidesPerView: 8,
                                        },
                                    }}
                                    modules={[Navigation, Pagination]}
                                    // slidesPerView={9}
                                    spaceBetween={20}
                                    pagination={{ clickable: true }}
                                    // loop={true}
                                    navigation={{ clickable: true }}
                                    className="select-none m-auto flex justify-center items-center ">
                                    {category.SubCategories.map((subCategory, i) => (
                                        <SwiperSlide key={i} className="cursor-pointer tracking-wider ">
                                            <Link key={subCategory._id} className="flex justify-center items-center" to={`/subcategories/${subCategory._id}`}>
                                                <img className="max-w-full" src={subCategory.Image.path} alt="" />
                                            </Link>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                            <div className="grid p-5 sm:p-2 grid-cols-1 xxs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-5 gap-6 lg:gap-8 my-8">
                                {categoryProducts.map((product, key) => (
                                    <div className="rounded border my-3 p-1 font-semibold flex flex-col justify-between group" key={key} >
                                        <div className="flex justify-end m-0 p-0 ">
                                            {!contains(ids, product._id) ?
                                                <button onClick={() => addProductToWishList(product?._id)} className='rounded text-red-800 p-1 border border-red-700 '><VscHeart className='group-hover:animate-bounce' size={18} /></button> :
                                                <button onClick={() => removeProductFromWishList(product?._id)} className='rounded text-red-800 p-1 border border-red-700 '><VscHeartFilled className='group-hover:animate-bounce' size={18} /></button>}
                                        </div>
                                        <Link to={`/products/${product._id}`} className="rounded px-1">
                                            <div className="bg-black">
                                                <img src={product.mainImage?.path} className='w-full' alt="product_Image" />
                                            </div>
                                            <div className="my-1">
                                                <p className="text-slate-500">{`${product.brandId?.name?.charAt(0).toUpperCase() + product.brandId?.name?.slice(1).split(' ').slice(0, 10).join(' ')}`}</p>
                                                <p className="text-slate-800">{`${product.name?.charAt(0).toUpperCase() + product.name?.slice(1).split(' ').slice(0, 7).join(' ')}....`}</p>
                                            </div>
                                            {product.discount > 0 ? <div className="flex items-center gap-4 w-full ">
                                                <p className="text-green-700">{product.priceAfterDiscount.toFixed(2)} EGP</p>
                                                <p className="text-gray-500 line-through">{product.price} EGP</p>
                                            </div> : <div className="flex items-center justify-between gap-2 w-full ">
                                                <p className="text-slate-800 ">{product.price} EGP</p>
                                            </div>}
                                            <div className='flex items-center gap-1.5 mt-2 bg-gray-50 shadow-sm rounded py-1 px-3 w-max my-2'>
                                                <FaStar className=" text-yellow-400" />
                                                <span>{product.AvgRate}</span>
                                            </div>
                                        </Link>
                                        {!cartContains(cartIds, product._id) ?
                                            <button onClick={() => addProductToCart(product._id, 1)} className='flex items-center justify-center gap-2 py-2 bg-green-600 hover:bg-green-500 text-white rounded w-full opacity-0 group-hover:opacity-100 duration-500'>
                                                <BsCartPlus className='group-hover:animate-bounce' />
                                                <span className='text-xs font-semibold  uppercase'> Add To Cart</span>
                                            </button> :
                                            <button onClick={() => removeProductFromCart(product._id)} className='flex items-center justify-center gap-2 py-2 bg-red-600 hover:bg-red-500 text-white rounded w-full opacity-0 group-hover:opacity-100 duration-500'>
                                                <BsCartDash className='group-hover:animate-bounce' />
                                                <span className='text-xs font-semibold  uppercase'> Remove From Cart</span>
                                            </button>}

                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </> : <LoadingPage />}
        </HelmetProvider>
    )
}

export default Category